import(/* webpackMode: "eager", webpackExports: ["FullPageLoading"] */ "/home/runner/work/frontend-monorepo/frontend-monorepo/apps/curology-sign-up/src/components/global/FullPageLoading.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/frontend-monorepo/frontend-monorepo/apps/curology-sign-up/src/components/navbar/NavBar.tsx");
